import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import AllMarkdown from './allmarkdown.js';
import { execSeatableSql } from './seatable.js';
import AllImg from './allimg.js';
import AllLogos from './alllogos.js';
import Typewriter from 'typewriter-effect';

function SectionHeader(props) {
    const { capability, section, imagePosition = 'left' } = props;
    const [data, setData] = useState(null);
    const [logoData, setLogoData] = useState(null);
    const [showMarkdown, setShowMarkdown] = useState(false);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT * FROM CapabilitySections WHERE \`Capability\` = '${capability}' AND \`PageSection\` = '${section}'`;
        setData(null);

        const logoSql = `SELECT fnMediaLink FROM SectionScrollingImage WHERE PageSection IN ('${section}') AND \`Capability\` IN ('${props.capability}') AND NOT isEmpty(fnMediaLink)`;
        setLogoData(null);

        try {
          const rows = await execSeatableSql(sql);
          setData(rows && rows.results[0]);

          const logoRows = await execSeatableSql(logoSql);
          const logoRowData = logoRows && logoRows.results;
          setLogoData(logoRowData.map(e => e.fnMediaLink));
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [capability, section]);

    const showPopup = () => {
      if (data && data["PopupLink"]) {
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const popupWidth = parseInt(screenWidth * 0.8);
        const popupHeight = parseInt(screenHeight * 0.8);
        const left = parseInt((screenWidth - popupWidth) / 2);
        const top = parseInt((screenHeight - popupHeight) / 2);

        const windowFeatures = `top=${top},left=${left},width=${popupWidth},height=${popupHeight},location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,titlebar=no,toolbar=no,directories=no`;
        window.open(data && data["PopupLink"], '_blank', windowFeatures);
      } else if (data && data["PopupText"]) {
        setShowMarkdown(true)
      }
    }

    return (<>
        {data && ((data["Section Title"] !== '') || (data["Section Sub Headline"] !== '')) ? (
          <div className={`section-header d-flex flex-column flex-md-row ${props.wrapper}`}>
            {(imagePosition && (imagePosition === 'left') && ((data && data["fnMediaLink"]) || (logoData && logoData.length > 0))) ? (
              <SectionLogo Logo={data && data["fnMediaLink"]} Title={data && data["Section Title"]} Logos={logoData} />
            ) : ''}
            <div className="mx-3 col-12 col-md-8 d-flex flex-column justify-content-center">
              <div data-aos="fade-right" data-aos-delay="100">
                  <div className="section-title lato-black">{data && data["Section Title"]}</div>
              </div>
              <div className="mt-3" data-aos="fade-right" data-aos-delay="100">
                  <div className="section-sub-title lato-light">
                    <AllMarkdown>{data && data["Section Sub Headline"]}</AllMarkdown>
                  </div>
              </div>
              {(data && data["PopupHeadline"]) ? (
              <div data-aos="fade-right" data-aos-delay="100">
                  <a className="section-sub-title lato-bold text-accent" href={() => false} onClick={showPopup}><span>{data && data["PopupHeadline"]}</span></a>
              </div>
              ) : ''}
              {data.HeroScrollingText && (data.HeroScrollingText.length > 0) ? (
              <div className="mt-3">
                  <Typewriter options={{
                      strings: data && data.HeroScrollingText.map(row => row.display_value), 
                      autoStart: true, 
                      loop: true, 
                      cursor: '_',
                      delay: '50',
                      wrapperClassName: "section-typing",
                      }} />
              </div>
              ) : ''}
            </div>
            {(imagePosition && (imagePosition === 'right') && ((data && data["fnMediaLink"]) || (logoData && logoData.length > 0))) ? (
              <SectionLogo Logo={data && data["fnMediaLink"]} Title={data && data["Section Title"]} Logos={logoData} />
            ) : ''}
            <Modal size="xl" show={showMarkdown} onHide={() => setShowMarkdown(false)} centered style={{zIndex: "99999"}}>
              <Modal.Header closeButton>
                <div className="d-flex flex-row">
                  <img className="my-auto" src="/favicon-16x16.png" alt="Allteam" />
                  <div className="mx-2 my-auto" style={{textTransform: 'uppercase', letterSpacing: '0.1rem'}}>{data && data["PopupHeadline"]}</div>
                </div>
              </Modal.Header>
              <Modal.Body>
                <AllMarkdown>{data && data["PopupText"]}</AllMarkdown>
              </Modal.Body>
            </Modal>
          </div>
        ) : ''}
    </>)
}

function SectionLogo(props) {
  return (
    <div className="mx-3 col-12 col-md-4 d-flex flex-column flex-md-row justify-content-center align-items-center" style={{minHeight: "300px"}}>
      {props && props.Logos && props.Logos.length > 0 ? (<>
        <AllLogos logos={props.Logos} />
      </>) 
      : (
        <AllImg className="my-3 img-fluid" src={props.Logo} alt={props.Title} />
      )}
    </div>
  )
}

export default SectionHeader;